import { Tabs } from "@newsela/angelou";

import { useSearchPageContext } from "@/search/NewSearchPageMVP/provider/SearchPageProvider";
import { SearchTags } from "../SearchTags";
import { useTaxonomyTagsContext } from "../TaxonomyTags.provider";
import { ITaxonomyCategorizedData } from "../TaxonomyTags.types";
import { createTabs } from "./TaxonomyModalTabs.utils";
import {
  modalDescriptionCss,
  tabPanelAdjustmentsCss,
} from "./TaxonomyModalTabs.styles";

interface ITaxonomyModalTabsProps {
  filteredData: ITaxonomyCategorizedData;
  handleSearch: (query: string) => void;
}

export const TaxonomyModalTabs = ({
  filteredData,
  handleSearch,
}: ITaxonomyModalTabsProps) => {
  const {
    getters: { isLoadingTaxonomyData },
  } = useSearchPageContext();
  const { isTabletOrMobileView } = useTaxonomyTagsContext();

  const handleTabClick = () => {
    setTimeout(() => {
      const container = document.getElementById("modal_description");
      if (container) {
        container.scrollTo({ top: 0, behavior: "smooth" });
      }
    }, 0);
  };

  return (
    <div id="modal_description" css={modalDescriptionCss}>
      {!isTabletOrMobileView && <SearchTags onSearch={handleSearch} />}
      <Tabs
        horizontalSwitch="sm"
        initialPanelId="all"
        panels={createTabs(filteredData, isLoadingTaxonomyData)}
        renderTabsAsButtons
        flavor="underlined"
        __cssFor={{
          root: tabPanelAdjustmentsCss,
        }}
        onClick={handleTabClick}
      />
    </div>
  );
};
